import React, { useContext,useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "@app/providers";

export function PrivateRoute({ children, ...rest }: any) {
  const { userInfo } = useContext(AuthContext);
  const userToken = userInfo && userInfo.sessionToken;
  // useEffect(()=>{
  //   console.log("test" + window.location.href)
  // },[])

  return (
    <Route
      {...rest}
      render={({ location }) =>
        userToken ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/sign-in",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
